import _range from 'lodash/range';
import { AFITD_WWW_DOMAIN_URL, DYNAMIC_LINK_PREFIX } from '../system/constants';
import { getEnvVariable } from './envHelper';

//set to PUBLIC_URL if deployed to eddie's home server; otherwise, ''.
export const BASE_URL = '';
export const BASE_PUBLIC_URL = process.env.PUBLIC_URL;
// export const BASE_URL = process.env.PUBLIC_URL;

export const JS_BASE_URL = `${AFITD_WWW_DOMAIN_URL}/talent`;
export const EMP_BASE_URL = `${AFITD_WWW_DOMAIN_URL}/brand`;

export const ADMIN_CONSOLE_PAGE_SIZE = 20;

// User Types
export const USER_TYPE_JS = 'JS';
export const USER_TYPE_MEMBER1 = 'MEMBER';
export const USER_TYPE_MEMBER2 = 'MEMBER2';
export const USER_TYPE_EMP = 'EMP';

// Account Status
export const ACCOUNT_STATUS_PENDING_EMAIL_VERIFICATION = 'PEV';
export const ACCOUNT_STATUS_PENDING_ACCOUNT_SETUP = 'PAS';
export const ACCOUNT_STATUS_PENDING_MEMBER_SETUP = 'PMS';
export const ACCOUNT_STATUS_PENDING_PAYMENT = 'PP';
export const ACCOUNT_STATUS_PAST_DUE = 'PAST_DUE';
export const ACCOUNT_STATUS_ACTIVE = 'A';
export const ACCOUNT_STATUS_INACTIVE = 'I';
export const ACCOUNT_STATUS_BANNED = 'B';

// Authentication Error Code
export const AUTH_ERROR_CODE_REQUIRES_RECENT_LOGIN = 'auth/requires-recent-login';

// App
export const JS_RECENT_SEARCHES_MAX = 5;
export const RECAPTCHA_SITE_KEY = getEnvVariable('RECAPTCHA_SITE_KEY');
export const ROUTE_TYPE_EMP = 'EMP';
export const ROUTE_TYPE_JS = 'JS';
export const ROUTE_TYPE_JOB_CENTER = 'JOB_CENTER';
export const ROUTE_TYPE_RESOURCE_CENTER = 'RESOURCE_CENTER';
export const ROUTE_TYPE_LOGIN = 'LOGIN';
export const ROUTE_TYPE_CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const ROUTE_TYPE_CREATE_ACCOUNT_JS = 'CREATE_ACCOUNT_JS';
export const ROUTE_TYPE_CREATE_ACCOUNT_EMP = 'CREATE_ACCOUNT_EMP';

// Home
export const HOMEPAGE_LANDING = 'Landing';
export const HOMEPAGE_EMPLOYERS = 'Employers';
export const HOMEPAGE_ABOUT = 'About-Us';
export const PATH_INTERNSHIP = 'internship';
export const HOMEPAGE_CONTACT = 'Contact-Us';
export const HOMEPAGE_FAQ = 'FAQ';
export const MESSAGE_MODE_CANCEL_PLAN_SUCCESSFUL = 'cancel_plan_successful';

// Dashboard
export const DASHBOARD_PLACEHOLDER = 'Placeholder';
export const DASHBOARD_MY_PROFILE = 'My Profile';
export const DASHBOARD_MY_CALENDAR = 'My Calendar';
export const DASHBOARD_MY_JOBS = 'My Jobs';
export const DASHBOARD_MY_SETTINGS = 'My Settings';
export const DASHBOARD_MY_MESSAGES = 'My Messages';
export const DASHBOARD_MY_ANALYTICS = 'My Analytics';
export const DASHBOARD_JOB_CENTER = 'Job Center';
export const DASHBOARD_TALENT_CENTER = 'Talent Center';

export const DASHBOARD_ID_MY_SETTINGS = '1';
export const DASHBOARD_ID_MY_PROFILE = '2';
export const DASHBOARD_ID_MY_JOBS = '3';
export const DASHBOARD_ID_MY_MESSAGES = '4';
export const DASHBOARD_ID_MY_CALENDAR = '5';

export const ADMIN_ID_JOB_SEEKER = '1';
export const ADMIN_ID_EMPLOYER_REGISTRATIONS = '2';
export const ADMIN_ID_ACCOUNT_DELETIONS = '3';
export const ADMIN_ID_ADVERTISEMENT_REQUESTS = '4';
export const ADMIN_ID_SURVEY_RESPONSES = '5';
export const ADMIN_ID_SUBSCRIPTION_CANCELLATIONS = '6';
export const ADMIN_ID_GOOGLE_ANALYTICS = '7';
export const ADMIN_ID_PRE_LAUNCH = '8';
export const ADMIN_ID_CONTACT_US = '9';
export const ADMIN_ID_ACTIVITY_STATS = '10';

export const ADMIN_UTIL_ID_JOB_LISTING_STATUS = '1';

export const DASHBOARD_ID_MY_SETTINGS_GENERAL = 'g';
export const DASHBOARD_ID_MY_SETTINGS_SUBSCRIPTION = 's';
export const DASHBOARD_ID_MY_SETTINGS_USERS = 'u';
export const DASHBOARD_ID_MY_SETTINGS_LINK = 'l';
export const DASHBOARD_ID_CHANGE_PASSWORD = 'p';
export const DASHBOARD_ID_MY_SETTINGS_MY_ACCOUNT = 'a';

export const ADVERTISE_PAGE_ID_INTRO = 'intro';
export const ADVERTISE_PAGE_ID_START = 'start';
export const ADVERTISE_PAGE_ID_STEP_1 = 'step1';
export const ADVERTISE_PAGE_ID_STEP_2 = 'step2';
export const ADVERTISE_PAGE_ID_STEP_3 = 'step3';
export const ADVERTISE_PAGE_ID_STEP_4 = 'step4';
export const ADVERTISE_PAGE_ID_STEP_5 = 'step5';
export const ADVERTISE_PAGE_ID_STEP_6 = 'step6';
export const ADVERTISE_PAGE_ID_SUCCESS = 'success';

// admin console / admin util
export const ADMIN_JOB_SEEKER_REGISTRATIONS = 'Job Seeker Registrations';
export const ADMIN_EMPLOYER_REGISTRATIONS = 'Employer Registrations';
export const ADMIN_ACCOUNT_DELETIONS = 'Account Deletions (JS)';
export const ADMIN_ADVERTISEMENT_REQUESTS = 'Advertisement Requests';
export const ADMIN_SURVEY_RESPONSES = 'Survey Responses';
export const ADMIN_SUBSCRIPTION_CANCELLATIONS = 'Subscription Cancellations';
export const ADMIN_GOOGLE_ANALYTICS = 'Google Analytics';
export const ADMIN_BLOCKED_USERS = 'Blocked Users';
export const ADMIN_PRE_LAUNCH_PAGE = 'Pre-Launch Page';
export const ADMIN_REPORTED_THREADS = 'Reported Threads';
export const ADMIN_CONTACT_US = 'Contact Us';
export const ADMIN_ACTIVITY_STATS = 'Activity Stats';
export const ADMIN_JOB_LISTING_STATUS = 'Update Job Draft/Public';

// survey
export const SURVEY_PAGE_ID_STEP_1 = 'step1';
export const SURVEY_PAGE_ID_STEP_2 = 'step2';
export const SURVEY_PAGE_ID_STEP_3 = 'step3';
export const SURVEY_PAGE_ID_SUCCESS = 'success';

export const BRAND_PAGE_TAB_ID_INFO = '1';
export const BRAND_PAGE_TAB_ID_JOBS = '2';

//Company info
export const DASHBOARD_PROFILE_COMPANY_TITLE = 'Company Info';
export const DASHBOARD_PROFILE_BRANDING = 'Branding';

// Calendar
export const CALENDAR_TYPE_MONTH = 'M';
export const CALENDAR_TYPE_WEEK = 'W';
export const CALENDAR_HOUR_HEIGHT = 80; // For the weekly calendar, the height of one hour
// export const CALENDAR_WEEKLY_HOURS_HEIGHT = 1580;  // For the weekly calendar, the height of the container containing 24 hours
export const CALENDAR_WEEKLY_HOURS_HEIGHT = 1943; // For the weekly calendar, the height of the container containing 24 hours

// Interview Status
export const INTERVIEW_STATUS_PENDING = 'PENDING';
export const INTERVIEW_STATUS_RESCHEDULE_JS = 'RESCHEDULE_JS';
export const INTERVIEW_STATUS_RESCHEDULE_EMP = 'RESCHEDULE_EMP';
export const INTERVIEW_STATUS_DECLINED = 'DECLINED';
export const INTERVIEW_STATUS_CONFIRMED = 'CONFIRMED';
export const INTERVIEW_STATUS_CANCELLED = 'CANCELLED';

// Snackbar
export const SNACK_BAR_MESSAGE_INTERVIEW_SUCCESS = 'Interview Request Sent successfully';
export const SNACK_BAR_MESSAGE_UPDATE_INTERVIEW_SUCCESS = 'Interview Updated successfully';
export const SNACK_BAR_MESSAGE_OPERATION_FAILED = 'Operation Failed';
export const SNACK_BAR_MESSAGE_TEXT_MODERATION_CHECK_FAILED = 'Text Violation Check Failed';
export const SNACK_BAR_MESSAGE_SAVE = 'Saved successfully';
export const SNACK_BAR_MESSAGE_SAVED_TO_DRAFT = 'Changed to Draft successfully';
export const SNACK_BAR_MESSAGE_SAVED_TO_PUBLIC = 'Changed to Public successfully';
export const SNACK_BAR_MESSAGE_URL_SAVED = 'URL saved successfully';
export const SNACK_BAR_MESSAGE_PASSWORD_SAVED = 'Password saved successfully';
export const SNACK_BAR_MESSAGE_INVITATION = 'Invitation sent successfully';
export const SNACK_BAR_MESSAGE_CONFIRM = 'Confirm successful';
export const SNACK_BAR_MESSAGE_SEND = 'Send successful';
export const SNACK_BAR_MESSAGE_INTERVIEW_RESCHEDULED = 'Interview rescheduled successfully';
export const SNACK_BAR_MESSAGE_SEND_FAILED = 'Failed to Send Message';
export const SNACK_BAR_MESSAGE_DECLINE = 'Decline Successful';
export const SNACK_BAR_MESSAGE_REPORT_THREAD = 'Thread Reported Successful';
export const SNACK_BAR_MESSAGE_DELETE_THREAD = 'Thread Deleted Successful';
export const SNACK_BAR_MESSAGE_THREAD_FOLLOW_UP = 'Marked for Follow Up';
export const SNACK_BAR_MESSAGE_THREAD_REMOVED_FOLLOW_UP = 'Removed Follow Up';
export const SNACK_BAR_MESSAGE_BLOCK_THREAD = 'Thread Blocked Successful';
export const SNACK_BAR_MESSAGE_UNBLOCK_THREAD = 'Thread Unblocked Successful';
export const SNACK_BAR_MESSAGE_DELETE = 'Job deleted successfully';
export const SNACK_BAR_MESSAGE_SAVE_TO_MY_JOBS = 'Saved to My Jobs successfully';
export const SNACK_BAR_MESSAGE_REMOVE_FROM_MY_JOBS = 'Removed from My Jobs successfully';
export const SNACK_BAR_MESSAGE_UPDATE_MY_JOBS = 'Updated My Jobs successfully';
export const SNACK_BAR_MESSAGE_DELETE_VIDEO = 'Video deleted successfully';
export const SNACK_BAR_MESSAGE_SAVED_HIRED_SUCCESS = 'Updated Hired Candidates successfully';
export const SNACK_BAR_MESSAGE_DELETE_TEAM_MEMBER = 'Deleted Member successfully';

export const JOB_APPLY_SUCCESS = 'Applied to Job successfully';
export const ADD_BOOKMARK_JOB_SUCCESS = 'Saved to My Jobs successfully';
export const REMOVE_BOOKMARK_JOB_SUCCESS = 'Removed from My Jobs';

// System Messages
export const MESSAGE_ALL_REQUIRED_FIELDS = 'You must enter all required fields.';
export const MESSAGE_ALL_REQUIRED_FIELDS_YEAR = 'You must enter all required fields and a valid year.';
export const MESSAGE_INVALID_YEAR = 'You must enter a valid year.';
export const MESSAGE_TITLE_ENGAGEMENT_INFO = 'What Does Engagement Mean?';
export const MESSAGE_ENGAGEMENT_INFO =
    'Engagement is either sending an interview request or a private message to a unique job seeker. Once you have engaged a job seeker you can send as many messages and schedule as many interviews as you like. The engagement allocation will be renewed every billing period.';
export const MESSAGE_TITLE_ONLY_JS_CAN_APPLY_JOB = 'Almost There';
export const MESSAGE_ONLY_JS_CAN_APPLY_JOB = 'Only Job Seekers with active accounts can apply to job listings';
export const MESSAGE_ONLY_JS_CAN_SAVE_JOB = 'Only Job Seekers with active accounts can save job listings';
export const MESSAGE_MUST_COMPLETE_ACCOUNT_SETUP_FIRST = 'You must complete account setup first.';
export const MESSAGE_TITLE_SALARY_RATE_INCOMPLETE = 'Salary/Rate Incomplete';
export const MESSAGE_SALARY_RATE_INCOMPLETE = 'Salary/Rate and Pay Frequency must both be blank or entered.';
export const MESSAGE_ACCOUNT_DELETED_SUCCESSFULLY = 'Your account has been deleted successfully.';

// Message Dialogs
export const MESSAGE_DIALOG_TITLE_THANK_YOU_FOR_PURCHASE = 'Thank You';

// Confirm Dialogs
export const CONFIRM_DIALOG_TITLE_CANCEL = 'Cancel?';
export const CONFIRM_DIALOG_MESSAGE_CANCEL = 'All unsaved data will be lost.';
export const CONFIRM_DIALOG_TITLE_CLEAR_ALL = 'Clear All Data?';
export const CONFIRM_DIALOG_MESSAGE_CLEAR_ALL = 'All unsaved data will be lost.';
export const CONFIRM_DIALOG_TITLE_DELETE_PROFILE_PHOTO = 'Delete Profile Photo?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_PROFILE_PHOTO = 'Your profile photo will be deleted.';
export const CONFIRM_DIALOG_TITLE_DELETE_LOGO = 'Delete Company Logo?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_LOGO = 'Your company logo will be deleted.';
export const CONFIRM_DIALOG_TITLE_DELETE_BANNER = 'Delete Banner?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_BANNER = 'Your company banner will be deleted.';
export const CONFIRM_DIALOG_TITLE_APPLY_JOB = 'Apply to Job?';
export const CONFIRM_DIALOG_MESSAGE_APPLY_JOB = 'Your application will be submitted to the employer for review and consideration.';
export const CONFIRM_DIALOG_TITLE_MAKE_PROFILE_PUBLIC = 'Your Profile is not Public';
export const CONFIRM_DIALOG_MESSAGE_MAKE_PROFILE_PUBLIC = `You must make your profile 'Public' on the My Profile page in order to 'Apply' to this job.`;
export const CONFIRM_DIALOG_TITLE_CREATE_NEW_JOB_FOR_INTERVIEW_OR_MESSAGE = 'No Active Jobs Available';
export const CONFIRM_DIALOG_MESSAGE_CREATE_NEW_JOB_FOR_INTERVIEW_OR_MESSAGE = 'You must have an Active Job available to';
export const CONFIRM_DIALOG_TITLE_DELETE_SAVED_JS = 'Remove Job Seeker?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_SAVED_JS = 'The Job Seeker will be removed from My Jobs.';
export const CONFIRM_DIALOG_TITLE_DELETE_SAVED_APPLICANT = 'Remove Applicant?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_SAVED_APPLICANT = 'The Applicant will be removed from My Jobs.';
export const CONFIRM_DIALOG_TITLE_REPORT_THREAD = 'Report Thread?';
export const CONFIRM_DIALOG_MESSAGE_REPORT_THREAD = 'This thread will be reported for inappropriate content.';
export const CONFIRM_DIALOG_TITLE_DELETE_THREAD = 'Delete Thread?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_THREAD = 'This thread will be deleted. You will no longer see this chat in My Messages.';
export const CONFIRM_DIALOG_TITLE_BLOCK_THREAD = 'Block This Thread?';
export const CONFIRM_DIALOG_MESSAGE_BLOCK_THREAD = 'This thread will be deactivated. You will no longer be able to send or receive messages in this thread.';
export const CONFIRM_DIALOG_TITLE_DELETE_VIDEO = 'Delete Video?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_VIDEO = 'Previously saved Video Overview will be permanently deleted.';
export const CONFIRM_DIALOG_TITLE_DELETE_JOB = 'Delete Job?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_JOB = 'This saved job will be deleted from My Jobs.';
export const CONFIRM_DIALOG_TITLE_EMP_DELETE_JOB = CONFIRM_DIALOG_TITLE_DELETE_JOB;
export const CONFIRM_DIALOG_MESSAGE_EMP_DELETE_JOB = 'It will be removed from your job listing and no longer be searchable by Job Seekers.';
export const CONFIRM_DIALOG_TITLE_MAKE_JOB_ACTIVE = 'Make Job Active?';
export const CONFIRM_DIALOG_MESSAGE_MAKE_JOB_ACTIVE = 'It will be searchable by Job Seekers.';
export const CONFIRM_DIALOG_TITLE_MAKE_JOB_INACTIVE = 'Make Job Inactive?';
export const CONFIRM_DIALOG_MESSAGE_MAKE_JOB_INACTIVE = 'It will no longer be searchable by Job Seekers.';
export const CONFIRM_DIALOG_TITLE_CANCEL_SELECTION = 'Cancel Selection?';
export const CONFIRM_DIALOG_MESSAGE_CANCEL_SELECTION = 'All unsaved data will be lost.';
export const CONFIRM_DIALOG_TITLE_RESEND_MEMBER_INVITE = 'Resend Invite?';
export const CONFIRM_DIALOG_MESSAGE_RESEND_MEMBER_INVITE = 'An invitation will be sent to the email address';
export const CONFIRM_DIALOG_MESSAGE_CONFIRM_DELETE_MEMBER = 'Are you sure you want to delete a team member from your account?';
export const CONFIRM_DIALOG_TITLE_CONFIRM_DELETE_MEMBER = 'Delete Team Member?';
export const CONFIRM_DIALOG_TITLE_CHANGE_PROFILE_TYPE_PUBLIC = 'Make Your Profile Public?';
export const CONFIRM_DIALOG_TITLE_CHANGE_PROFILE_TYPE_DRAFT = 'Change Your Profile to Draft?';
export const CONFIRM_DIALOG_MESSAGE_CHANGE_PROFILE_TYPE_PUBLIC = 'Your profile will be live and available to be reviewed and searched by employers.';
export const CONFIRM_DIALOG_MESSAGE_CHANGE_PROFILE_TYPE_DRAFT = 'Your profile will no longer be available to be reviewed and searched by employers.';
export const CONFIRM_DIALOG_MESSAGE_CHANGE_BRAND_PAGE_PUBLIC = 'Your brand page will be live and viewable by public.';
export const CONFIRM_DIALOG_MESSAGE_CHANGE_BRAND_PAGE_DRAFT = 'Your brand page will no longer be viewable by public.';
export const CONFIRM_DIALOG_TITLE_CREATE_ACCOUNT_DIFF_EMAIL = 'Create Account with a Different Email Address?';
export const CONFIRM_DIALOG_MESSAGE_CREATE_ACCOUNT_DIFF_EMAIL = 'You will not be able to accept the invitation with this email address.';
export const CONFIRM_DIALOG_TITLE_CREATE_JS_ACCOUNT = 'Create Job Seeker Account?';
export const CONFIRM_DIALOG_MESSAGE_CREATE_JS_ACCOUNT = 'You will not be able to accept the invitation as a job seeker.';
export const CONFIRM_DIALOG_TITLE_CHANGE_PROFILE_TO_DRAFT = 'Edit Your Profile?';
export const CONFIRM_DIALOG_MESSAGE_CHANGE_EMP_PROFILE_TO_DRAFT = `Your Profile will be in 'Draft' mode and your brand page will no longer be viewable by public.`;
export const CONFIRM_DIALOG_MESSAGE_CHANGE_JS_PROFILE_TO_DRAFT = `Your Profile will be in 'Draft' mode and will no longer be available to be reviewed and searched by employers.`;
export const CONFIRM_DIALOG_TITLE_ADD_NEW_COMPANY_TO_CURRENT_ACCOUNT = 'Add New Company to Current Account?';
// export const CONFIRM_DIALOG_MESSAGE_ADD_NEW_COMPANY_TO_CURRENT_ACCOUNT = '';
export const CONFIRM_DIALOG_TITLE_DELETE_ACCOUNT_JS = 'Delete Account?';
export const CONFIRM_DIALOG_MESSAGE_DELETE_ACCOUNT_JS =
    'Your account will be deleted. Your profile will not be searchable and employers will no longer be able to communicate with you on our platform.';
export const CONFIRM_DIALOG_BUTTON_LABEL_YES_DELETE_MY_ACCOUNT = 'YES. Delete My Account';

export const CONFIRM_DIALOG_TITLE_DOWNGRADE_SUBSCRIPTION = 'Downgrade Subscription?';
export const CONFIRM_DIALOG_CANCEL_BUTTON_TEXT = 'No, I changed my mind';
export const CONFIRM_DIALOG_SAVE_BUTTON_TEXT = 'Yes, Downgrade to Tier';
export const CONFIRM_DIALOG_MESSAGE_DOWNGRADE_SUBSCRIPTION_TIER2 = 'When you downgrade you will lose your full company branding and 2 seats. Are you sure?';
export const CONFIRM_DIALOG_MESSAGE_DOWNGRADE_SUBSCRIPTION_TIER3 =
    'When you downgrade you will lose branding, Tier 3 badge, consolidated job listing page and many seats. Are you sure?';
export const CONFIRM_DIALOG_ELIGIBLE_FOR_REFUND_HEADING = 'Full Refund Eligible';
export const CONFIRM_DIALOG_ELIGIBLE_FOR_REFUND_MESSAGE = 'You will receive a full refund for the amount charged to your account. We are sorry to  see you leave soon.';
export const CONFIRM_DIALOG_ACCOUNT_CANCELATION_HEADING = 'Account Cancellation';
export const CONFIRM_DIALOG_ACCOUNT_CANCELLATION_MESSAGE = 'You can continue using the platform until the end of your billing period. We are sorry to see you go.';
export const CONFIRM_DIALOG_ADDITIONAL_SEAT_ELIGIBLE_FOR_REFUND_HEADING = 'Full Refund Eligible';
export const CONFIRM_DIALOG_ADDITIONAL_SEAT_ELIGIBLE_FOR_REFUND_MESSAGE = 'You will receive a full refund for the amount charged to your account.';
export const CONFIRM_DIALOG_ADDITIONAL_SEAT_CANCELATION_HEADING = 'Account Cancellation';
export const CONFIRM_DIALOG_ADDITIONAL_SEAT_CANCELATION_MESSAGE = 'You can continue using the additional seats until the end of your billing period.';

// Profile Page
export const PROFILE_TYPE_PUBLIC = 'P';
export const PROFILE_TYPE_DRAFT = 'D';
export const PROFILE_ABOUT_ME = 'About Me';
export const PROFILE_RESUME = 'Resume';
export const PROFILE_VIDEO_OVERVIEW = 'Video Overview';
export const PROFILE_SOCIAL_MEDIA = 'Social Media and Portfolio';
export const PROFILE_SOCIAL_MEDIA_FACEBOOK = 'Facebook';
export const PROFILE_SOCIAL_MEDIA_LINKEDIN = 'LinkedIn';
export const PROFILE_SOCIAL_MEDIA_INSTAGRAM = 'Instagram';
export const PROFILE_SOCIAL_MEDIA_YOUTUBE = 'YouTube';
export const PROFILE_SOCIAL_MEDIA_TWITTER = 'Twitter';
export const PROFILE_SOCIAL_MEDIA_WEBSITE = 'Website';
export const PROFILE_SOCIAL_MEDIA_TIKTOK = 'TikTok';
export const PROFILE_SOCIAL_MEDIA_GITHUB = 'GitHub';
export const PROFILE_SOCIAL_MEDIA_X = 'X';

// Video Profile (Video Overfiew)
export const VIDEO_OVERVIEW_MODE_VIEW_EXISTING = 1;
export const VIDEO_OVERVIEW_MODE_RECORD = 2;
export const VIDEO_OVERVIEW_MODE_FROM_CAMERA = 3;
export const VIDEO_OVERVIEW_MODE_FROM_LIBRARY = 4;

// Alert Messages
export const ALERT_NEW_JOB_APPLICATION = 'New Job Application';
export const ALERT_NEW_MESSAGE = 'New Message';
export const ALERT_NEW_INTERNAL_MESSAGE = 'New Internal Message';
export const ALERT_NEW_PENDING_INTERVIEW = 'New Pending Interview';
export const ALERT_NEW_RESCHEDULED_INTERVIEW = 'New Rescheduled Interview';
export const ALERT_NEW_CONFIRM_INTERVIEW = 'New Confirmed Interview';
export const ALERT_NEW_DECLINED_INTERVIEW = 'New Declined Interview';

// Scroll-To Elements
export const SCROLL_TO_ELEMENT_ABOUT_ME = 'SCROLL_TO_ELEMENT_ABOUT_ME';
export const SCROLL_TO_ELEMENT_RESUME = 'SCROLL_TO_ELEMENT_RESUME';
export const SCROLL_TO_ELEMENT_VIDEO_OVERVIEW = 'SCROLL_TO_ELEMENT_VIDEO_OVERVIEW';
export const SCROLL_TO_ELEMENT_SOCIAL_MEDIA_PORTFOLIO = 'SCROLL_TO_ELEMENT_SOCIAL_MEDIA_PORTFOLIO';

// Filter options
export const FILTER_OPTION_JOB_TYPE_ALL_JOB_TYPES = 'All Job Types';
export const FILTER_OPTION_JOB_TYPE_FULL_TIME = 'Full-Time';
export const FILTER_OPTION_JOB_TYPE_PART_TIME = 'Part-Time';
export const FILTER_OPTION_JOB_TYPE_CONTRACTOR = 'Contractor';
export const FILTER_OPTION_JOB_TYPE_CONTRACT_TO_HIRE = 'Contract to Hire';
export const FILTER_OPTION_JOB_TYPE_SEASONAL_TEMP = 'Seasonal / Temp';
export const FILTER_OPTION_JOB_TYPE_GIG_WORK = 'Gig-Work';
export const FILTER_OPTION_JOB_TYPE_PER_DIEM = 'Per Diem';

export const JOB_TYPE_FILTER_OPTIONS = [
    FILTER_OPTION_JOB_TYPE_ALL_JOB_TYPES,
    FILTER_OPTION_JOB_TYPE_FULL_TIME,
    FILTER_OPTION_JOB_TYPE_PART_TIME,
    FILTER_OPTION_JOB_TYPE_CONTRACTOR,
    FILTER_OPTION_JOB_TYPE_CONTRACT_TO_HIRE,
    FILTER_OPTION_JOB_TYPE_SEASONAL_TEMP,
    FILTER_OPTION_JOB_TYPE_GIG_WORK,
    FILTER_OPTION_JOB_TYPE_PER_DIEM,
];

export const FILTER_OPTION_DATE_POSTED_WITHIN_24_HOURS = 'within 24 hours';
export const FILTER_OPTION_DATE_POSTED_WITHIN_3_DAYS = 'within 3 days';
export const FILTER_OPTION_DATE_POSTED_WITHIN_7_DAYS = 'within 7 days';
export const FILTER_OPTION_DATE_POSTED_WITHIN_30_DAYS = 'within 30 days';
export const FILTER_OPTION_DATE_POSTED_OVER_30_DAYS = 'over 30 days';

export const FILTER_DATE_POST_WITHIN_DAYS = {
    [FILTER_OPTION_DATE_POSTED_WITHIN_24_HOURS]: 1,
    [FILTER_OPTION_DATE_POSTED_WITHIN_3_DAYS]: 3,
    [FILTER_OPTION_DATE_POSTED_WITHIN_7_DAYS]: 7,
    [FILTER_OPTION_DATE_POSTED_WITHIN_30_DAYS]: 30,
};

export const DATE_POSTED_FILTER_OPTIONS = [
    FILTER_OPTION_DATE_POSTED_WITHIN_24_HOURS,
    FILTER_OPTION_DATE_POSTED_WITHIN_3_DAYS,
    FILTER_OPTION_DATE_POSTED_WITHIN_7_DAYS,
    FILTER_OPTION_DATE_POSTED_WITHIN_30_DAYS,
    FILTER_OPTION_DATE_POSTED_OVER_30_DAYS,
];

export const FILTER_OPTION_SALARY_ANY_SALARY = 'Any Salary';
export const FILTER_OPTION_SALARY_2K = 20000;
export const FILTER_OPTION_SALARY_4K = 40000;
export const FILTER_OPTION_SALARY_6K = 60000;
export const FILTER_OPTION_SALARY_8K = 80000;
export const FILTER_OPTION_SALARY_10K = 100000;
export const FILTER_OPTION_SALARY_12K = 120000;

export const SALARY_FILTER_OPTIONS = [
    FILTER_OPTION_SALARY_ANY_SALARY,
    FILTER_OPTION_SALARY_2K,
    FILTER_OPTION_SALARY_4K,
    FILTER_OPTION_SALARY_6K,
    FILTER_OPTION_SALARY_8K,
    FILTER_OPTION_SALARY_10K,
    FILTER_OPTION_SALARY_12K,
];

export const FILTER_OPTION_RATE_ANY_RATE = 'Any Rate';

export const getRateFilterOptions = () => {
    const options = _range(1, 21);
    return [FILTER_OPTION_RATE_ANY_RATE, ...options];
};

export const FILTER_OPTION_PAY_FREQUENCY_ANY_FREQUENCY = 'Any Frequency';
export const PAY_FREQUENCY_LIST_YEARLY = 'Yearly';
export const PAY_FREQUENCY_LIST_MONTHLY = 'Monthly';
export const PAY_FREQUENCY_LIST_BI_WEEKLY = 'Bi-Weekly';
export const PAY_FREQUENCY_LIST_WEEKLY = 'Weekly';
export const PAY_FREQUENCY_LIST_DAILY = 'Daily';
export const PAY_FREQUENCY_LIST_HOURLY = 'Hourly';
export const PAY_FREQUENCY_LIST_PER_JOB = 'Per Job';

export const PAY_FREQUENCY_FILTER_OPTIONS = [
    FILTER_OPTION_PAY_FREQUENCY_ANY_FREQUENCY,
    PAY_FREQUENCY_LIST_YEARLY,
    PAY_FREQUENCY_LIST_MONTHLY,
    PAY_FREQUENCY_LIST_BI_WEEKLY,
    PAY_FREQUENCY_LIST_WEEKLY,
    PAY_FREQUENCY_LIST_DAILY,
    PAY_FREQUENCY_LIST_HOURLY,
    PAY_FREQUENCY_LIST_PER_JOB,
];

export const FREQUENCY = { Yearly: 'Year', Monthly: 'Month', Daily: 'Day', 'Bi-Weekly': 'Bi-Weekly', Weekly: 'Week', Hourly: 'Hour' };

export const WORK_FROM_HOME = 'Work from Home';
export const TELEWORK_LIST_COMPLETE = 'Complete Telework';
export const TELEWORK_LIST_PARTIAL = 'Partial Telework';
export const TELEWORK_LIST_NO = 'No Telework';

// Sort Options
export const SORT_OPTION_NEWEST_FIRST = 'Newest first';
export const SORT_OPTION_OLDEST_FIRST = 'Oldest first';
export const SORT_OPTION_DATE_NEWEST_FIRST = 'Date (Newest first)';
export const SORT_OPTION_DATE_OLDEST_FIRST = 'Date (Oldest first)';
export const SORT_OPTION_DATE = 'Date';
export const SORT_OPTION_DISTANCE = 'Distance';
export const SORT_OPTION_RELEVANCE = 'Relevance';

// Labels
export const LABEL_CURRENCY = 'Currency';
export const LABEL_PAY_FREQUENCY = 'Pay Frequency';
export const LABEL_YEARS_OF_EXPERIENCE = 'Years of Experience';
export const LABEL_WILLING_TO_RELOCATE_QUESTION = 'Willing to Relocate?';
export const LABEL_INDUSTRY = 'Industry';
export const LABEL_FOUNDED = 'Year Founded';
export const LABEL_COMPANY_SIZE = 'Company Size';
export const LABEL_LOCATION = 'Location';

// Missing field values
export const ALL = 'All';
export const COMPANY_NAME_MISSING = 'Company Name Missing';
export const CURRENCY_MISSING = 'Currency Missing';
export const EMAIL_MISSING = 'Email Missing';
export const JOB_TITLE_MISSING = 'Job Title Missing';
export const LOCATION_MISSING = 'Location Missing';
export const NAME_MISSING = 'Name Missing';
export const OCCUPATION_MISSING = 'Desired Occupation Missing';
export const TITLE_MISSING = 'Title Missing';
export const DEFAULT_CURRENCY_SYMBOL = '$';

// Error messages
export const ERROR_MESSAGE_VIDEO_EXCEED_60_SECONDS = 'Video must not be longer than 60s';
export const ERROR_MESSAGE_INVALID_VIDEO = 'Invalid video / Duration cannot be determined';
export const ERROR_MESSAGE_INVALID_URL = 'Invalid URL';
export const ERROR_MESSAGE_INVALID_YEAR = 'Invalid Year';
export const ERROR_MESSAGE_FILE_NOT_ALLOWED = 'The selected file is not allowed';
export const ERROR_MESSAGE_FILE_SIZE_NOT_OVER_15MB = 'The selected file may not exceed 15MB';
export const ERROR_MESSAGE_FILE_SIZE_NOT_OVER_5MB = 'The selected file may not exceed 5MB';
export const ERROR_MESSAGE_INVITEE_EXISTS_IN_MEMBERS = 'User is already a team member';
export const ERROR_MESSAGE_INVITEE_PENDING = 'You have already invited this user';
export const ERROR_MESSAGE_WEAK_PASSWORD =
    'Password must be minimum 8 chracters long and should contain at least 1 lowercase letter, 1 uppercase letter, 1 special character, and 1 number';
export const ERROR_MESSAGE_NOT_VALID_EMAIL = 'Please enter a valid email';

// Analytics event names
export const ANALYTICS_EVENT_SIGN_UP = 'sign_up';
export const ANALYTICS_EVENT_LOGIN = 'login';
export const ANALYTICS_EVENT_PAGE_VIEW = 'page_view';

// Analytics event names (custom)
export const ANALYTICS_EVENT_PASSWORD_RESET = 'password_reset';
export const ANALYTICS_EVENT_EMAIL_VERIFIED = 'email_verified';

export const ANALYTICS_EVENT_SEARCH_FILTER = 'search_filter';
export const ANALYTICS_EVENT_SEARCH = 'search';

export const ANALYTICS_EVENT_JOB_LISTING_CREATED = 'job_listing_created';
export const ANALYTICS_EVENT_JOB_LISTING_SET_ACTIVE = 'job_listing_set_active';
export const ANALYTICS_EVENT_JOB_LISTING_SET_INACTIVE = 'job_listing_set_inactive';
export const ANALYTICS_EVENT_JOB_LISTING_DELETED = 'job_listing_deleted';

export const ANALYTICS_EVENT_TALENT_PROFILE_PREVIEW = 'talent_profile_preview';
export const ANALYTICS_EVENT_TALENT_PROFILE_PUBLISHED = 'talent_profile_published';
export const ANALYTICS_EVENT_BRAND_PAGE_PREVIEW = 'brand_page_preview';
export const ANALYTICS_EVENT_BRAND_PAGE_PUBLISHED = 'brand_page_published';

export const ANALYTICS_EVENT_JS_APPLIED_JOB = 'js_applied_job';
export const ANALYTICS_EVENT_JS_SAVED_JOB = 'js_saved_job';
export const ANALYTICS_EVENT_JS_MY_JOBS_SEARCH = 'js_my_jobs_search';
export const ANALYTICS_EVENT_EMP_SAVED_TALENT = 'emp_saved_talent';

export const ANALYTICS_EVENT_INTERVIEW_CREATED = 'interview_created';
export const ANALYTICS_EVENT_INTERVIEW_CONFIRMED = 'interview_confirmed';
export const ANALYTICS_EVENT_VIRTUAL_INTERVIEW_CONFIRMED = 'virtual_interview_confirmed';
export const ANALYTICS_EVENT_PHYSICAL_INTERVIEW_CONFIRMED = 'physical_interview_confirmed';
export const ANALYTICS_EVENT_INTERVIEW_DECLINED = 'interview_declined';
export const ANALYTICS_EVENT_VIRTUAL_INTERVIEW_JOINED = 'virtual_interview_joined';
export const ANALYTICS_EVENT_EXTERNAL_MESSAGE_THREAD_CREATED = 'external_message_thread_created';
export const ANALYTICS_EVENT_INTERNAL_MESSAGE_THREAD_CREATED = 'Internal_message_thread_created';
export const ANALYTICS_EVENT_EMP_INVITE_ACCEPTED = 'emp_invite_accepted';

export const ANALYTICS_EVENT_SURVEY_SUBMITTED = 'survey_submitted';

// Analytics event params
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_JOB_CENTER_JOB_TYPE = 'Job Center Job Types';
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_JOB_CENTER_SALARY_RATE = 'Job Center Salary Rate';
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_JOB_CENTER_DATE_POSTED = 'Job Center Date Posted';
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_JOB_CENTER_WORK_FROM_HOME = 'Job Center Work from Home';
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_JOB_CENTER_INTERN_POSITIONS = 'Job Center Intern Positions';
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_TALENT_CENTER_JOB_TYPE = 'Talent Center Job Types';
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_TALENT_CENTER_SALARY_RATE = 'Talent Center Salary Rate';
export const ANALYTICS_EVENT_PARAM_SEARCH_FILTER_TALENT_CENTER_WILLING_TO_RELOCATE = 'Talent Center Willing to Relocate';

// Page titles
export const PAGE_TITLE_ABOUT_US = 'About Us';
export const PAGE_TITLE_ABOUT_US_SEO = 'Learn more About Us';
export const PAGE_TITLE_ACCOUNT_SETUP = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
export const PAGE_TITLE_ADMIN_CONSOLE = 'Admin Console';
export const PAGE_TITLE_ADVERTISE_WITH_US = 'Advertise With Us';
export const PAGE_TITLE_AUTH = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
export const PAGE_TITLE_AUTH_HANDLER = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
export const PAGE_TITLE_BRAND_PAGE = 'Company Brand Page';
export const PAGE_TITLE_CONTACT_US = 'Contact Us';
export const PAGE_TITLE_CONTACT_US_SEO = 'Get in Touch with Us';
export const PAGE_TITLE_DASHBOARD = 'Dashboard';
export const PAGE_TITLE_EMP = 'Company Brand Page';
export const PAGE_TITLE_EMP_ACCOUNT_LINKAGE = 'Employer Account Linkage';
export const PAGE_TITLE_EMP_INVITE_HANDLER = 'Employer Invitation';
export const PAGE_TITLE_EMP_MEMBER_SETUP = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx';
export const PAGE_TITLE_EMP_MY_CALENDAR = 'My Calendar | Employer Dashboard ';
export const PAGE_TITLE_EMP_MY_JOBS = 'My Jobs | Employer Dashboard ';
export const PAGE_TITLE_EMP_MY_MESSAGES = 'My Messages | Employer Dashboard ';
export const PAGE_TITLE_EMP_MY_PROFILE = 'My Profile | Employer Dashboard ';
export const PAGE_TITLE_EMP_MY_SETTINGS = 'My Settings | Employer Dashboard ';
export const PAGE_TITLE_EMP_SEARCH = 'Employer Search';
export const PAGE_TITLE_EMPLOYERS = 'Employers';
export const PAGE_TITLE_EMPLOYERS_SEO = 'Hire Talented Employees with 60-Second Interview Pitch';
export const PAGE_TITLE_INTERNSHIP_SEO = 'Internship Program';
export const PAGE_TITLE_EXTERNAL_VIRTUAL_INTERVIEW = 'External Virtual Interview';
export const PAGE_TITLE_FORGOT_PASSWORD = 'Forgot Password?';
export const PAGE_TITLE_HOME = 'Home';
export const PAGE_TITLE_HOME_SEO = 'Find Your Dream Job with Our Job-Seeking Platform';
export const PAGE_TITLE_LOGIN = 'Log In';
export const PAGE_TITLE_JITSI = 'Jitsi Shout Out';
export const PAGE_TITLE_JOB_CENTER = 'Job Center';
export const PAGE_TITLE_JOIN_INTERVIEW = 'Virtual Interview';
export const PAGE_TITLE_JS = 'Talent Profile';
export const PAGE_TITLE_JS_MY_CALENDAR = 'My Calendar | Job Seeker Dashboard';
export const PAGE_TITLE_JS_MY_JOBS = 'My Jobs | Job Seeker Dashboard';
export const PAGE_TITLE_JS_MY_MESSAGES = 'My Messages | Job Seeker Dashboard';
export const PAGE_TITLE_JS_MY_PROFILE = 'My Profile | Job Seeker Dashboard';
export const PAGE_TITLE_JS_MY_SETTINGS = 'My Settings | Job Seeker Dashboard';
export const PAGE_TITLE_MESSAGE = 'The Message';
export const PAGE_TITLE_PRIVACY = 'Privacy Policy';
export const PAGE_TITLE_RESOURCE_CENTER = 'Resource Center';
export const PAGE_TITLE_SURVEY = 'Survey';
export const PAGE_TITLE_TALENT_CENTER = 'Talent Center';
export const PAGE_TITLE_TALENT_PROFILE = 'Talent Profile';
export const PAGE_TITLE_TERMS = 'Terms of Use';
export const PAGE_TITLE_TERMS_SEO = 'Terms and Conditions of Use';
export const PAGE_TITLE_VIRTUAL_INTERVIEW = 'Virtual Interview';

// Regex
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

// TOOLTIP
export const TOOLTIP_EMP_MEMBER_COUNTRY = "If your work location is different from your company's location, please change it here.";
export const TOOLTIP_EMP_MEMBER_USE_COMPANY_LOCATION = "If your work location is the same as your company's location, click this link to copy company's location to your location.";

// Misc
export const ACTIVE_JOBS = 'Active Jobs';
export const ADD_NEW_COMPANY = 'Add New Company';
export const ADD_REMOVE = 'Add/Remove';
export const ADD_REMOVE_ADDITIONAL_SEATS = 'Add/Remove Additional Seats';
export const ANY_JOB_TITLES = 'Any Job Titles';
export const ANY_OCCUPATIONS = 'Any Occupations';
export const BUY_NOW = 'Buy Now';
export const CANCEL = 'Cancel';
export const CANCEL_ALL = 'Cancel All';
export const CHANGE_BILLING_INTERVAL = 'Change Billing Interval';
export const CHANGE_TO_MONTHLY = 'Change to Monthly';
export const CHANGE_TO_YEARLY = 'Change to Yearly';
export const COMPANY = 'Company';
export const DATE = 'Date';
export const DISTANCE = 'Distance';
export const EDIT_INTERVIEW_REQUEST = 'Edit Interview Request';
export const EDIT_INFO = 'Edit Information';
export const EDIT_OWNER_ADMIN_INFO = 'Edit Owner / Admin Information';
export const EDIT_MEMBER_INFO = 'Edit Member Information';
export const GO_TO_MY_DASHBOARD = 'Go to My Dashboard';
export const GO_TO_MY_SETTINGS = 'Go to My Settings';
export const HERE = 'Here';
export const INVITATION_DECLINED = 'Invitation Declined';
export const INVITATION_SENT = 'Invitation Sent';
export const JOB_APPLICATION = 'Job Application';
export const JOB_LIST_NOT_EXISTS_OR_NOT_ACTIVE = 'The job listing does not exist or is no longer active';
export const LOG_IN = 'Log In';
export const NO_MESSAGE_SELECTED = "You don't have a message selected";
export const NO_MESSAGES_TO_DISPLAY = 'No Messages to display';
export const NO_JOB_SELECTED = "You don't have a job listing selected";
export const NO_JOBS_FOUND = 'No jobs found';
export const ONLY_EMPLOYERS_CAN_INITIATE_THREAD = 'Only employers can initiate a message thread';
export const OTHER_COMPANIES = 'Other Companies';
export const OTHER_LINKED_COMPANIES = 'Other Linked Companies';
export const OTHER_ACCOUNTS = 'Other Accounts';
export const PASSWORDS_DO_NOT_MATCH = 'Passwords do not match';
export const PENDING_ACCOUNT_SETUP = 'Pending Account Setup';
export const PENDING_EMPLOYER_INVITATIONS = 'Pending Employer Invitations';
export const PLEASE_CHECK_BACK_VERY_SOON = 'Please check back very soon';
export const PLEASE_ENTER_MORE_DETAILS_TRY_AGAIN = 'Please enter more details and try again';
export const PLEASE_SELECT_A_JOB_LISTING_TO_VIEW_DETAILS = 'Please select a job listing to view the details';
export const PLEASE_SELECT_A_JOB_SEEKER_TO_VIEW_PROFILE = 'Please select a job seeker to view their profile';
export const PLEASE_SELECT_THREAD_TO_VIEW_DETAILS = 'Please choose a thread to view the details';
export const POSTED_ON = 'POSTED ON';
export const PROCEED_TO_PAYMENT = 'Proceed to Payment';
export const PURCHASE = 'Purchase';
export const PURCHASE_ADDITIONAL_SEATS = 'Purchase Additional Seats';
export const RECORD_VIDEO = 'Record Video';
export const RECORD_UPLOAD_VIDEO = 'Record or Upload Video';
export const REQUEST_INTERVIEW = 'Request Interview';
export const REQUIRED = 'Required';
export const SAVE = 'Save';
export const SEARCH = 'Search';
export const SEND_EMAIL_AGAIN = 'Send Email Again';
export const SEND_IT_AGAIN = 'Send It Again';
export const SEND_MESSAGE = 'Send Message';
export const SET_UP_MEMBER_INFO = 'Set Up Member Information';
export const SELECT_CANDIDATE_HIRED = 'Select Candidate Hired';
export const SUBMIT_ORDER = 'Submit Order';
export const THE_JOB_LISTING_CANNOT_BE_FOUND = 'The job listing cannot be found';
export const THERE_ARE_NO_JOB_SEEKERS_MATCH_CRITERIA = 'There are no job seekers that match the criteria';
export const THERE_ARE_NO_JOB_LISTINGS_MATCH_CRITERIA = 'There are no job listings that match the criteria';
export const THERE_ARE_NO_JOB_LISTINGS_TO_DISPLAY_AT_THE_MOMENT = 'There are no job listings to display at the moment';
export const THERE_ARE_NO_JOB_SEEKERS_TO_DISPLAY_AT_THE_MOMENT = 'There are no job seekers to display at the moment';
export const THIS_THREAD_HAS_BEEN_DEACTIVATED = 'This thread has been deactivated';
export const USE_COMPANY_LOCATION = "Use Company's Location";
export const USE_HEADQUARTER_LOCATION = 'Use Headquarter/Head Office Location';
export const UPDATED_INTERVIEW_REQUEST = 'Updated Interview Request';
export const UPDATED_ON = 'UPDATED ON';
export const UPDATE_DELETE_VIDEO = 'Update/Delete Video';
export const VISIT_BRAND_PAGE = "Visit Company's Brand Page";
export const VIEW_ACTIVE_JOBS = 'View Active Jobs';
export const YOU_MUST_ACCEPT_TERMS_BEFORE_SUBMITTING = 'You must accept terms and conditions before submitting.';
export const YOUR_COMPANY = 'Your Company';

// Info
export const INFO_TEXT_TRACK_EMP_HIRING_STATISTICS =
    'We will not display this information to your employer. We will be tracking employer hiring statistics to ensure equal opportunities for all as best as we can.';

export const KEY_CODE_SEMICOLON = 186;

export const EMP_MY_JOBS_JOB_SEEKERS_LIST_TYPE_SAVED = 'S';
export const EMP_MY_JOBS_JOB_SEEKERS_LIST_TYPE_APPLIED = 'A';

export const GET_DATE_CODE = { 'MM/DD/CCYY': 'MM/dd/yyyy', 'DD/MM/CCYY': 'dd/MM/yyyy' };
export const GET_DATE_DESCRIPTION = { 'MM/dd/yyyy': 'MM/DD/CCYY', 'dd/MM/yyyy': 'DD/MM/CCYY' };

export const GET_TIME_CODE = { '12H (AM/PM)': 'h:mm a', '24H': 'HH:mm' };
export const GET_TIME_DESCRIPTION = { 'h:mm a': '12H (AM/PM)', 'HH:mm': '24H' };

// Auth error codes
// export const AUTH_ERROR_CODE_ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL = 'auth/account-exists-with-different-credential';
// export const AUTH_ERROR_CODE_ARGUMENT_ERROR = 'auth/argument-error';
// export const AUTH_ERROR_CODE_AUTH_DOMAIN_CONFIG_REQUIRED = 'auth/auth-domain-config-required';
// export const AUTH_ERROR_CODE_CANCELLED_POPUP_REQUEST = 'auth/cancelled-popup-request';
// export const AUTH_ERROR_CODE_CAPTCHA_CHECK_FAILED = 'auth/captcha-check-failed';
// export const AUTH_ERROR_CODE_ CREDENTIAL_ALREADY_IN_USE= 'auth/credential-already-in-use';
export const AUTH_ERROR_CODE_EMAIL_ALREADY_IN_USE = 'auth/email-already-in-use';
// export const AUTH_ERROR_CODE_EXPIRED_ACTION_CODE = 'auth/expired-action-code';
// export const AUTH_ERROR_CODE_INVALID_ACTION_CODE = 'auth/invalid-action-code';
// export const AUTH_ERROR_CODE_INVALID_CONTINUE_URI = 'auth/invalid-continue-uri';
// export const AUTH_ERROR_CODE_INVALID_CREDENTIAL = 'auth/invalid-credential';
export const AUTH_ERROR_CODE_INVALID_EMAIL = 'auth/invalid-email';
// export const AUTH_ERROR_CODE_INVALID_PERSISTENCE_TYPE = 'auth/invalid-persistence-type';
// export const AUTH_ERROR_CODE_INVALID_PHONE_NUMBER = 'auth/invalid-phone-number';
// export const AUTH_ERROR_CODE_INVALID_USER_TOKEN = 'auth/invalid-user-token';
// export const AUTH_ERROR_CODE_INVALID_VERIFICATION_CODE = 'auth/invalid-verification-code';
// export const AUTH_ERROR_CODE_INVALID_VERIFICATION_ID = 'auth/invalid-verification-id';
// export const AUTH_ERROR_CODE_MISSING_ANDROID_PKG_NAME = 'auth/missing-android-pkg-name';
// export const AUTH_ERROR_CODE_MISSING_CONTINUE_URI = 'auth/missing-continue-uri';
// export const AUTH_ERROR_CODE_MISSING_IOS_BUNDLE_ID = 'auth/missing-ios-bundle-id';
// export const AUTH_ERROR_CODE_MISSING_PHONE_NUMBER = 'auth/missing-phone-number';
// export const AUTH_ERROR_CODE_NULL_USER = 'auth/null-user';
// export const AUTH_ERROR_CODE_OPERATION_NOT_ALLOWED = 'auth/operation-not-allowed';
// export const AUTH_ERROR_CODE_OPERATION_NOT_SUPPORTED_IN_THIS_ENVIRONMENT = 'auth/operation-not-supported-in-this-environment';
// export const AUTH_ERROR_CODE_POPUP_BLOCKED = 'auth/popup-blocked';
// export const AUTH_ERROR_CODE_POPUP_CLOSED_BY_USER = 'auth/popup-closed-by-user';
// export const AUTH_ERROR_CODE_PROVIDER_ALREADY_LINKED = 'auth/provider-already-linked';
// export const AUTH_ERROR_CODE_QUOTE_EXCEEDED = 'auth/quota-exceeded';
// export const AUTH_ERROR_CODE_TENANT_ID_MISMATCH = 'auth/tenant-id-mismatch';
// export const AUTH_ERROR_CODE_TIMEOUT = 'auth/timeout';
// export const AUTH_ERROR_CODE_UNAUTHORIZED_CONTINUE_URI = 'auth/unauthorized-continue-uri';
// export const AUTH_ERROR_CODE_UNAUTHORIZED_DOMAIN = 'auth/unauthorized-domain';
// export const AUTH_ERROR_CODE_UNSUPPORTED_PERSISTENCE_TYPE = 'auth/unsupported-persistence-type';
// export const AUTH_ERROR_CODE_USER_DISABLED = 'auth/user-disabled';
export const AUTH_ERROR_CODE_USER_NOT_FOUND = 'auth/user-not-found';
// export const AUTH_ERROR_CODE_USER_TOKEN_EXPIRED = 'auth/user-token-expired';
// export const AUTH_ERROR_CODE_WEAK_PASSWORD = 'auth/weak-password';
export const AUTH_ERROR_CODE_WRONG_PASSWORD = 'auth/wrong-password';

// Auth error messages
// export const AUTH_ERROR_MSG_ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL = '';
// export const AUTH_ERROR_MSG_ARGUMENT_ERROR = '';
// export const AUTH_ERROR_MSG_AUTH_DOMAIN_CONFIG_REQUIRED = '';
// export const AUTH_ERROR_MSG_CANCELLED_POPUP_REQUEST = '';
// export const AUTH_ERROR_MSG_CAPTCHA_CHECK_FAILED = '';
// export const AUTH_ERROR_MSG_ CREDENTIAL_ALREADY_IN_USE= '';
export const AUTH_ERROR_MSG_EMAIL_ALREADY_IN_USE = 'This email account is already on file.';
// export const AUTH_ERROR_MSG_EXPIRED_ACTION_CODE = '';
// export const AUTH_ERROR_MSG_INVALID_ACTION_CODE = '';
// export const AUTH_ERROR_MSG_INVALID_CONTINUE_URI = '';
// export const AUTH_ERROR_MSG_INVALID_CREDENTIAL = '';
export const AUTH_ERROR_MSG_INVALID_EMAIL = 'Invalid email address format.';
// export const AUTH_ERROR_MSG_INVALID_PERSISTENCE_TYPE = '';
// export const AUTH_ERROR_MSG_INVALID_PHONE_NUMBER = '';
// export const AUTH_ERROR_MSG_INVALID_USER_TOKEN = '';
// export const AUTH_ERROR_MSG_INVALID_VERIFICATION_CODE = '';
// export const AUTH_ERROR_MSG_INVALID_VERIFICATION_ID = '';
// export const AUTH_ERROR_MSG_MISSING_ANDROID_PKG_NAME = '';
// export const AUTH_ERROR_MSG_MISSING_CONTINUE_URI = '';
// export const AUTH_ERROR_MSG_MISSING_IOS_BUNDLE_ID = '';
// export const AUTH_ERROR_MSG_MISSING_PHONE_NUMBER = '';
// export const AUTH_ERROR_MSG_NULL_USER = '';
// export const AUTH_ERROR_MSG_OPERATION_NOT_ALLOWED = '';
// export const AUTH_ERROR_MSG_OPERATION_NOT_SUPPORTED_IN_THIS_ENVIRONMENT = '';
// export const AUTH_ERROR_MSG_POPUP_BLOCKED = '';
// export const AUTH_ERROR_MSG_POPUP_CLOSED_BY_USER = '';
// export const AUTH_ERROR_MSG_PROVIDER_ALREADY_LINKED = '';
// export const AUTH_ERROR_MSG_QUOTE_EXCEEDED = '';
// export const AUTH_ERROR_MSG_TENANT_ID_MISMATCH = '';
// export const AUTH_ERROR_MSG_TIMEOUT = '';
// export const AUTH_ERROR_MSG_UNAUTHORIZED_CONTINUE_URI = '';
// export const AUTH_ERROR_MSG_UNAUTHORIZED_DOMAIN = '';
// export const AUTH_ERROR_MSG_UNSUPPORTED_PERSISTENCE_TYPE = '';
// export const AUTH_ERROR_MSG_USER_DISABLED = '';
export const AUTH_ERROR_MSG_USER_NOT_FOUND = 'The email address / password entered do not match our record.';
// export const AUTH_ERROR_MSG_USER_TOKEN_EXPIRED = '';
// export const AUTH_ERROR_MSG_WEAK_PASSWORD = '';
export const AUTH_ERROR_MSG_WRONG_PASSWORD = 'The email address / password entered do not match our record.';

export const AUTH_ERROR_MSG_DEFAULT = 'Operation failed.  Please try again later.';

// Emp Invitation error codes
export const EMP_ACC_LINKAGE_STATUS_CODE_INVITATION_INVALID = 'invitation-invalid';
export const EMP_ACC_LINKAGE_STATUS_CODE_INVITATION_ALREADY_ACCEPTED = 'invitation-already-accepted';
export const EMP_ACC_LINKAGE_STATUS_CODE_JOB_SEEKER_INVITEE = 'job-seeker-invitee';
export const EMP_ACC_LINKAGE_STATUS_CODE_INVITEE_ACCOUNT_NOT_EXISTS = 'invitee-account-not-exists';
export const EMP_ACC_LINKAGE_STATUS_CODE_SUCCESSFUL = 'linkage-successful';

// Interview join code/link status codes
export const INTERVIEW_CODE_INVALID = 'INTERVIEW_CODE_NOT_FOUND';
export const INTERVIEW_NOT_CONFIRMED = 'INTERVIEW_NOT_CONFIRMED';
export const INTERVIEW_CODE_EXPIRED = 'INTERVIEW_CODE_EXPIRED';
export const INTERVIEW_CODE_VALID = 'INTERVIEW_CODE_VALID';
// export const EMP_ACC_LINKAGE_STATUS_CODE_ = '';

// Emp Invitation error messages
export const EMP_ACC_LINKAGE_STATUS_MSG_INVITATION_INVALID = 'The invitation is invalid or has already been accepted.';
export const EMP_ACC_LINKAGE_STATUS_MSG_INVITATION_ALREADY_ACCEPTED = 'The invitation is invalid or has already been accepted.';
export const EMP_ACC_LINKAGE_STATUS_MSG_JOB_SEEKER_INVITEE = 'The invitee is associated to a job seeker account.';
// export const EMP_ACC_LINKAGE_STATUS_MSG_INVITEE_ACCOUNT_NOT_EXISTS = '';
// export const EMP_ACC_LINKAGE_STATUS_MSG_SUCCESSFUL = '';

// ElasticSearch error codes
export const ELASTIC_SEARCH_JWT_STATUS_CODE_USER_NOT_AUTHORIZED = 'user-not-authorized';

// ElasticSearch error messages

// Jitsi error codes
export const JITSI_JWT_STATUS_CODE_USER_NOT_AUTHORIZED = 'user-not-authorized';

// Sight Engine APi Keys
export const SIGHTENGINE_BASE_URL = 'https://api.sightengine.com/1.0';
export const SIGHTENGINE_API_USER = '';
export const SIGHTENGINE_API_SECRET = '';

// Job Seeker Video Status
export const UPLOADED_VIDEO_STATUS_PROCESSING = 'P';
export const UPLOADED_VIDEO_STATUS_FAILED = 'F';
export const UPLOADED_VIDEO_STATUS_APPROVED = 'A';
export const UPLOADED_VIDEO_STATUS_COMPRESSING = 'C';
export const UPLOADED_VIDEO_STATUS_DELETED = 'D';

// Pricing
export const PRICE_ADVERTISEMENT_PLACEMENT = 599;

// social links
export const FACEBOOK_SOCIAL_URL = 'https://www.facebook.com/afootinthedoorwork';

export const LINKEDIN_SOCIAL_URL = 'https://www.linkedin.com/company/a-foot-in-the-door-inc/';
export const FACEBOOK_SOCIAL_MOBILE_URL = 'https://facebook.openinapp.co/afootinthedoorwork-1';

export const INSTAGRAM_SOCIAL_URL = 'https://www.instagram.com/afootinthedoor_work/';

export const TIKTOK_SOCIAL_URL = 'https://www.tiktok.com/@a_foot_in_the_door?is_from_webapp=1&sender_device=pc';

export const YOUTUBE_SOCIAL_URL = 'https://www.youtube.com/channel/UCT6Z3_e5AgfVvcI0_8tlIdQ';

// Dynamic Link URL's
export const DYNAMIC_LINK_LOG_IN = `${DYNAMIC_LINK_PREFIX}/log-in`;
export const DYNAMIC_LINK_MY_SETTINGS = `${DYNAMIC_LINK_PREFIX}/my-settings`;
